import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import { AlertTriangle, ArrowRight } from 'lucide-react';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

/**
 * Sticky top banner — Aktif görev sayısını gösterir.
 * Aktif görev varsa SÜREKLİ görünür, kapatma butonu YOK.
 * Görevler tamamlanınca (total=0) kendiliğinden kalkar.
 * Tıklanınca /tasks?myActive=1 sayfasına gider.
 * Mobile + Desktop responsive.
 */
export default function ActiveTasksBanner() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [summary, setSummary] = useState(null);

  // Özet veriyi yükle (2 dk'da bir yenile)
  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const load = async () => {
      try {
        const res = await axios.get(`${API}/users/me/active-tasks-summary?limit=1`);
        if (!cancelled) setSummary(res.data || null);
      } catch (e) {
        // sessiz
      }
    };
    load();
    const t = setInterval(load, 120000);
    return () => { cancelled = true; clearInterval(t); };
  }, [user]);

  // Görevler sayfasındayken banner görünmesin (gereksiz tekrar)
  if (!user || !summary) return null;
  if ((summary.total || 0) === 0) return null;
  if (location.pathname.startsWith('/tasks')) return null;

  const counts = summary.counts || {};
  const handleClick = () => navigate('/tasks?myActive=1');

  return (
    <div
      data-testid="active-tasks-banner"
      onClick={handleClick}
      className="sticky top-0 z-[40] cursor-pointer bg-gradient-to-r from-red-600 via-rose-600 to-red-600 text-white shadow-md hover:from-red-700 hover:via-rose-700 hover:to-red-700 transition"
    >
      <div className="max-w-screen-2xl mx-auto px-3 sm:px-5 py-2 flex items-center gap-2 sm:gap-3">
        <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 animate-pulse" />
        <div className="flex-1 min-w-0 flex flex-wrap items-baseline gap-x-2 sm:gap-x-3 text-xs sm:text-sm">
          <span className="font-bold whitespace-nowrap">
            {summary.total} aktif görev
          </span>
          <span className="hidden sm:inline opacity-70">•</span>
          <span className="opacity-95 whitespace-nowrap">
            <b>{counts['beklemede'] || 0}</b> Beklemede
          </span>
          <span className="opacity-95 whitespace-nowrap">
            <b>{counts['işlemde'] || 0}</b> İşlemde
          </span>
          <span className="opacity-95 whitespace-nowrap">
            <b>{counts['incelemede'] || 0}</b> İncelemede
          </span>
        </div>
        <span className="hidden md:inline-flex items-center gap-1 text-xs font-semibold whitespace-nowrap">
          Görevlere Git
          <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </div>
  );
}
